import React, { Component } from "react";
import { Button, Col, Grid, Row } from "react-bootstrap";
import Divider from "../../lib/divider";
import "./promotions-dashboard.scss";
import { HAS_SEEN_PROMOTIONS_INTRO } from "../../../constants/user_attributes";
import get from "lodash/get";
import some from "lodash/some";
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";

import { If } from "react-extras";
import { Link } from "react-router-dom";
import getFP from "lodash/fp/get";
import BrowseRow from "../browse_promotion/browse_row";
import Spinner from "../../lib/spinner";
import "../../../css/icons.scss";
import MyCrossPromotionsTable from "./my_cross_promotions_table";
import { getBiggestShow, isShowEligibleForCrossPromo } from "../../../lib/show";
import InfoTooltip from "../../lib/info";

class PromotionsDashboard extends Component {
  state = {
    // we present recommendations based off of the showUUID in the state
    showUUID: null,
    showsFetched: false,
    showsToBrowse: [],
  };

  componentDidMount() {
    this.props.fetchShowsForUser(this.props.user).then(() => {
      this.fetchRelatedShows();
      this.setState({ showsFetched: true });
    });
    this.props.getDealsForUser(this.props.user);
  }

  fetchRelatedShows = () => {
    const shows = this.getShowArray();
    const eligibleShows = filter(shows, isShowEligibleForCrossPromo);
    const biggestShow = getBiggestShow(eligibleShows);
    if (!isEmpty(biggestShow.uuid)) {
      this.props.searchSimilarShows(biggestShow.uuid);
      this.setState({ showUUID: biggestShow.uuid });
    }
  };

  getShowArray = () => {
    return Object.values(get(this.props, "shows", {})).filter(getFP("isVisible"));
  };

  hasSeenIntro = () => {
    return get(this.props.user, ["userAttributes", HAS_SEEN_PROMOTIONS_INTRO]) === "true";
  };

  hasAnOptedInShow = () => {
    const showMap = get(this.props, "shows", {});
    return some(Object.keys(showMap), key => get(showMap[key], "canShareAudienceSize"));
  };

  getShowsToBrowse = () => {
    if (this.state.showsToBrowse.length) {
      return this.state.showsToBrowse;
    }

    if (this.props.categoryShows.isLoading || this.props.categoryDirectoryShows.isLoading) {
      return undefined;
    }

    if (!isEmpty(this.state.showUUID)) {
      const shows = get(this.props.categoryShows, [this.state.showUUID], []);
      if (shows.length) {
        this.setState({ showsToBrowse: shows });
      }
      return shows;
    }
    return [];
  };

  renderEmptyState = () => {
    const hasSeenIntro = this.hasSeenIntro();
    const hasOptedIn = this.hasAnOptedInShow();
    let button = (
      <Button
        className="btn btn-primary margin-right--large"
        to={"/"}
        onClick={this.props.showIntroModal}>
        Get Started
      </Button>
    );
    if (hasSeenIntro && hasOptedIn) {
      button = (
        <Button
          className="btn btn-primary margin-right--large"
          to={"/"}
          onClick={() => this.props.history.push("/promotions/browse")}>
          Find Podcast Partners
        </Button>
      );
    }

    return (
      <div className={"promotions-page__empty-state-container"}>
        <h4>
          You aren
          {"'"}t running any cross promotions yet
        </h4>
        {button}
      </div>
    );
  };

  render() {
    const { deals = {} } = this.props;
    const hasOptedIn = this.hasAnOptedInShow();
    const numDeals = get(deals, "userDealUUIDs.length", 0);
    const isDealsLoading = get(deals, "isLoading", true);

    return (
      <div className="promotions-page-content page-wrapper">
        <Grid fluid>
          <Row>
            <Col xs={12} />
          </Row>
          <Row>
            <Col xs={12}>
              <div className="promotions-dashboard__my-promos">
                <div className="flex-row-container">
                  <h1 className="promotions-dashboard__inbox-title">My Cross Promotions</h1>
                  <div className="promotions-dashboard__question-button-wrapper">
                    <span
                      onClick={this.props.showIntroModal}
                      className="promotions-dashboard__question-button">
                      ?
                    </span>
                  </div>
                  <If condition={this.hasAnOptedInShow()}>
                    <div className="promotions-dashboard__new-promotion">
                      <Link to="/promotions/browse" className="bold">
                        New Promotion
                      </Link>
                    </div>
                  </If>
                </div>
                <Spinner isLoading={isDealsLoading} />
                <If condition={!isDealsLoading}>
                  <If condition={numDeals > 0}>
                    <MyCrossPromotionsTable />
                  </If>
                  <If condition={!numDeals}>{this.renderEmptyState()}</If>
                </If>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} style={{ marginTop: "114px" }}>
              <div className={"flex-row-container align-center margin-bottom--medium"}>
                <h1 className={"promotions-dashboard__title no-margin"}>Browse</h1>
                <span className="promotions-page__browse-description flex-1 margin-left--small">
                  <span className="hidden-xs">Find other podcasters to promote with</span>
                </span>
                <If condition={!isEmpty(this.props.shows)}>
                  <Link
                    onClick={() => !hasOptedIn && this.props.showOptInModal()}
                    to={hasOptedIn ? "/promotions/browse" : "#"}
                    className="bold no-style-link">
                    Browse All
                    <span className="chevron--right" />
                  </Link>
                </If>
                <If condition={isEmpty(this.props.shows)}>
                  <div className="bold pointer disabled">
                    Browse All
                    <InfoTooltip helpText={"cannot browse partners without at least one podcast"} />
                    <span className="chevron--right" />
                  </div>
                </If>
              </div>
              <Divider smallMargin />
              <If condition={isEmpty(this.props.shows)}>
                <div className="promotions-page__empty-state-container">
                  <h4>You must have at least one podcast to browse cross promotion partners.</h4>
                </div>
              </If>
              <If condition={!isEmpty(this.props.shows)}>
                <BrowseRow
                  shows={this.getShowsToBrowse()}
                  isLoading={this.props.isLoading || this.props.isLoadingBrowse}
                />
              </If>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default PromotionsDashboard;
